// extracted by mini-css-extract-plugin
export var mt0 = "slim-hero-module--mt-0--f70b8";
export var mt1 = "slim-hero-module--mt-1--6244c";
export var mt2 = "slim-hero-module--mt-2--a5e7c";
export var mt3 = "slim-hero-module--mt-3--3288e";
export var mt4 = "slim-hero-module--mt-4--7fb1b";
export var mt5 = "slim-hero-module--mt-5--812a2";
export var mt6 = "slim-hero-module--mt-6--7a910";
export var slimHero = "slim-hero-module--slim-hero--e7b96";
export var slimHeroDark = "slim-hero-module--slim-hero--dark--e97ab";
export var slimHero__body = "slim-hero-module--slim-hero__body--54476";
export var slimHero__left = "slim-hero-module--slim-hero__left--1d982";
export var slimHero__left__copy = "slim-hero-module--slim-hero__left__copy--c4ea1";
export var slimHero__left__cta = "slim-hero-module--slim-hero__left__cta--30965";
export var slimHero__left__ctas = "slim-hero-module--slim-hero__left__ctas--670df";
export var slimHero__left__eyebrow = "slim-hero-module--slim-hero__left__eyebrow--91ebb";
export var slimHero__left__eyebrowIcon = "slim-hero-module--slim-hero__left__eyebrow-icon--66118";
export var slimHero__left__eyebrowWrapper = "slim-hero-module--slim-hero__left__eyebrow-wrapper--aa91f";
export var slimHero__left__headline = "slim-hero-module--slim-hero__left__headline--c1122";
export var slimHero__right = "slim-hero-module--slim-hero__right--19df9";
export var slimHero__right__img = "slim-hero-module--slim-hero__right__img--dde4f";
export var slimHero__right__video = "slim-hero-module--slim-hero__right__video--a9c28";
export var slimHero__right__videoWrapper = "slim-hero-module--slim-hero__right__video-wrapper--663a1";